import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  return <section className="w-full bg-[#faf7f2] py-20 px-4" data-id="element-186">
      <div className="max-w-5xl mx-auto" data-id="element-187">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-188">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#5b8a7a]" data-id="element-189">
            <h3 className="font-serif text-2xl text-[#0f172a] mb-6 flex items-center gap-3" data-id="element-190">
              <span className="bg-[#dcfce7] p-2 rounded-full" data-id="element-191">
                <Check className="w-5 h-5 text-[#166534]" data-id="element-192" />
              </span>
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-193">
              {['Estás en 0–12 semanas', 'Tu bebé despierta mucho', 'Tú te sientes ansiosa de noche', 'Quieres algo corto, imprimible, repetible', 'Quieres enfoque suave + micro-hábitos'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#475569]" data-id="element-194">
                  <Check className="w-5 h-5 text-[#5b8a7a] shrink-0 mt-0.5" data-id="element-195" />
                  <span data-id="element-196">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#94a3b8]" data-id="element-197">
            <h3 className="font-serif text-2xl text-[#0f172a] mb-6 flex items-center gap-3" data-id="element-198">
              <span className="bg-[#f1f5f9] p-2 rounded-full" data-id="element-199">
                <X className="w-5 h-5 text-[#64748b]" data-id="element-200" />
              </span>
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-201">
              {['Buscas un programa largo de “sleep training” formal', 'Quieres promesas de “dormir toda la noche”', 'Hay señales de alarma médica (ahí se consulta)'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#475569]" data-id="element-202">
                  <X className="w-5 h-5 text-[#94a3b8] shrink-0 mt-0.5" data-id="element-203" />
                  <span data-id="element-204">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}